'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var styles = _ref.styles;
  var colors = _ref2.colors,
      measures = _ref2.measures,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      treatments = _ref2.treatments;

  var defaultStyles = {
    root: _extends({
      display: 'block',
      fontWeight: 700,
      fontSize: scale(-0.5),
      lineHeight: measures.medium,
      textAlign: 'left',
      marginBottom: rhythm(0.25)
    }, treatments.label, {

      '& a': {
        color: colors.primary,
        textDecoration: 'underline'
      }
    }),

    required: {
      display: 'inline-block',
      color: colors.danger,
      cursor: 'help'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/label/styles.js
// module id = 850
// module chunks = 0